import {Container, Graphics, Text} from "pixi.js";
import {Vector} from "../i.js"; // ../vector.js
import {logger} from "../i.js"; // ../logger.js
import {RESOURCES, RESOURCE_INFO} from "../i.js"; // ../drop.js
import {UIUtils} from "../i.js"; // ../ui/utils.js
import {Button} from "../i.js"; // ./button.js
import {Tab} from "../i.js"; // ./tab.js
import {ACHIEVEMENTS} from "../i.js";

export class Upgrader extends Tab {
	// Info about nature and cost of upgrades
	static UPGRADE_INFO = [
		{
			name: "Blaster damage",
			unit: "b",
			levels: [
				{
					value: 5,
					cost: new Map()
				},
				{
					value: 6,
					cost: new Map([
						[RESOURCES.MINERALS, 25]
					])
				},
				{
					value: 7,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					])
				},
				{
					value: 8,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					])
				},
				{
					value: 9,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					])
				},
				{
					value: 10,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					])
				}
			]
		},
		{
			name: "Health",
			unit: "b",
			levels: [
				{
					value: 25,
					cost: new Map()
				},
				{
					value: 30,
					cost: new Map([
						[RESOURCES.MINERALS, 1]
					])
				},
				{
					value: 35,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					])
				},
				{
					value: 40,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					])
				},
				{
					value: 45,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					])
				},
				{
					value: 50,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					])
				}
			]
		},
		{
			name: "Speed",
			unit: "f/s",
			levels: [
				{
					value: 2,
					cost: new Map()
				},
				{
					value: 2.2,
					cost: new Map([
						[RESOURCES.MINERALS, 25]
					])
				},
				{
					value: 2.4,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					])
				},
				{
					value: 2.6,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					])
				},
				{
					value: 2.8,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					])
				},
				{
					value: 3,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					])
				}
			]
		},
	];

	// Create a new upgrader
	// Each unicenter should create exactly one upgrader.
	//
	// Args:
	//   unicenter - reference to the unicenter
	//   savefile  - optional savefile (object)
	constructor(unicenter, savefile) {
		super(unicenter,
			new Set(["Origin Station"]),
			Tab.LOCATIONS.LEFT,
			"images/icons/upgrader.svg",
			0,
			"Upgrader"
		);

		this._levels = Upgrader.UPGRADE_INFO.map(() => 0);
		let savedLevels = savefile?.l ?? [];
		if (savedLevels.length >= this._levels.length) {
			for (let i = 0; i < this._levels.length; ++i) {
				if (0 <= savedLevels[i] && savedLevels[i]
								< Upgrader.UPGRADE_INFO[i].levels.length) {
					this._levels[i] = savedLevels[i];
				}
			}
		}
		this.thrustersForged = savefile?.tf ?? false;

		// Visuals

		this.display.title = new Text("Upgrader", UIUtils.getFont(this.colorHighlight));

		this.display.techSelectors = new Container();
		Upgrader.UPGRADE_INFO.forEach(upgrade => {
			let techButton = new Button(unicenter);
			this.display.techSelectors.addChild(techButton);
		});
		this._selectedTech = null;

		this.display.selectTechTip = new Text(
			"Select a technology to upgrade",
			UIUtils.getFont(this.colorHighlight)
		);

		this.display.upgradeBox = new Graphics();

		this.display.upgradeTitle = new Text(
			"",
			UIUtils.getFont(this.colorHighlight)
		);
		this.display.upgradeButton = new Button(unicenter);

		this.display.upgradeBox.addChild(
			this.display.upgradeTitle,
			this.display.upgradeButton
		);

		this.display.addChild(
			this.display.title,
			this.display.techSelectors,
			this.display.selectTechTip,
			this.display.upgradeBox
		);

		// Old stuff

		// this.display.upgradeButtons = new Container();
		// this.display.upgradeButtons.position.set(0, 0);
		// for (let i = 0; i < Upgrader.UPGRADE_INFO.length; ++i) {
		// 	this.display.upgradeButtons.addChild(new Button(unicenter));
		// }
		// this.display.addChild(this.display.upgradeButtons);

		// this.display.forgeButton = new Button(unicenter);
		// this.display.addChild(this.display.forgeButton);
	}

	// Update the upgrader
	// Call this every tick. visible is a boolean that is true if the display is
	// visible this tick. size is a vector in pixels representing the desired
	// size of the display.
	update(visible, size) {
		if (visible) {
			if (this.display.upgradeButton.wasClicked()) {
				this._tryUpgrade(this._selectedTech);
			}
			this.display.techSelectors.children.forEach((techButton, i) => {
				if (techButton.wasClicked()) {
					this._selectedTech = (this._selectedTech === i) ? null : i;
				}
			});
			// Old stuff
			// for (let i = 0; i < Upgrader.UPGRADE_INFO.length; ++i) {
			// 	if (this.display.upgradeButtons.children[i].wasClicked()) {
			// 		this._tryUpgrade(i);
			// 	}
			// }
			// if (this.display.forgeButton.wasClicked()
			// 				&& this.unicenter.inventory.hasStar()) {
			// 	this.thrustersForged = true;
			// 	this.unicenter.ship.achievements.recordAchievement(
			// 		ACHIEVEMENTS.THRUSTERS
			// 	);
			// }
		}

		super.update(visible, size);

		this.display.techSelectors.children.forEach(
			techButton => techButton.clearStuff()
		);
		this.display.upgradeButton.clearStuff();

		// Old stuff

		// for (let i = 0; i < Upgrader.UPGRADE_INFO.length; ++i) {
		// 	this.display.upgradeButtons.children[i].clearStuff();
		// }
		// this.display.forgeButton.clearStuff();
	}

	save() {
		return {
			l: [...this._levels],
			tf: this.thrustersForged
		};
	}

	// Get the value for an upgradable number
	// All upgrades are pulled by whatever needs them, not pushed by upgrader.
	// name is a string.
	getValue(name) {
		let techIndices = new Map([
			["DAMAGE", 0],
			["HEALTH", 1],
			["SPEED", 2]
		]);

		if (!techIndices.has(name)) {
			logger.error("upgrader.js", `unknown name ${name}`);
			return 0;
		}

		let techIndex = techIndices.get(name);
		let upgrade = Upgrader.UPGRADE_INFO[techIndex];
		let level = this._levels[techIndex];
		return upgrade.levels[level].value;
	}

	// Check whether the player can currently upgrade / forge anything
	anythingToDo() {
		for (let i = 0; i < Upgrader.UPGRADE_INFO.length; ++i) {
			let upgrade = Upgrader.UPGRADE_INFO[i];
			let level = this._levels[i];

			// Max level, upgrade impossible
			if (level === upgrade.levels.length - 1) continue;

			// Enough resources to upgrade, that's something to do!
			let cost = upgrade.levels[level + 1].cost;
			if (this.unicenter.refinery.canAfford(cost)) {
				return true;
			}
		}

		// Nothing to do :(
		return false;
	}

	// Refresh the display, redrawing everything from scratch
	// This method only needs to be called when something actually changed, but
	// it's okay to call it every tick.
	_refreshDisplay() {
		let size = this.display.size;
		let narrowMargin = this.unicenter.requestMarginWidth(1);
		let wideMargin = this.unicenter.requestMarginWidth(2);

		this.display.title.style.fontSize = this.unicenter.requestFontSize("LARGE");

		let techSelectorsOrigin = new Vector(
			0,
			this.display.title.height + wideMargin
		).round();
		this.display.techSelectors.position.copyFrom(techSelectorsOrigin);

		let techButtonSize = new Vector(size.y / 10, size.y / 10).round();
		let techButtonOrigin = new Vector();
		this.display.techSelectors.children.forEach((techButton, i) => {
			techButton.update(
				this.colorBase,
				this.colorHighlight,
				techButtonOrigin,
				techButtonSize,
				Upgrader.UPGRADE_INFO[i].name[0]
			);
			techButtonOrigin.x += techButtonSize.x + narrowMargin;
		});

		let upgradeBoxOrigin = new Vector(
			0,
			techSelectorsOrigin.y + techButtonSize.y + narrowMargin
		);
		let upgradeBoxSize = Vector.diff(size, upgradeBoxOrigin);

		let selectTechTip = this.display.selectTechTip;
		let upgradeBox = this.display.upgradeBox;
		if (this._selectedTech === null) {
			selectTechTip.visible = true;
			selectTechTip.style.fontSize = this.unicenter.requestFontSize("SMALL");
			selectTechTip.position.copyFrom(
				Vector.diff(
					upgradeBoxSize,
					new Vector(selectTechTip.width, selectTechTip.height)
				)
					.scale(0.5)
					.add(upgradeBoxOrigin)
					.round()
			);

			upgradeBox.visible = false;
		} else {
			selectTechTip.visible = false;

			let upgrade = Upgrader.UPGRADE_INFO[this._selectedTech];
			let level = this._levels[this._selectedTech];

			upgradeBox.visible = true;
			upgradeBox.position.copyFrom(upgradeBoxOrigin);
			upgradeBox
				.clear()
				.lineStyle(this.unicenter.requestStroke(this.colorHighlight, "NARROW"))
				.drawRect(
					0, 0,
					upgradeBoxSize.x, upgradeBoxSize.y
				);

			let upgradeTitle = this.display.upgradeTitle;
			let upgradeTitleOrigin = new Vector(
				narrowMargin, narrowMargin
			);
			upgradeTitle.position.copyFrom(upgradeTitleOrigin);
			upgradeTitle.style.fontSize = this.unicenter.requestFontSize("LARGE");
			upgradeTitle.text = upgrade.name;

			let upgradeButtonSize = new Vector(
				upgradeBoxSize.x - 2 * narrowMargin,
				(upgradeBoxSize.y - 2 * narrowMargin) / 3
			).round();
			let upgradeButtonOrigin = new Vector(
				narrowMargin,
				upgradeBoxSize.y - narrowMargin - upgradeButtonSize.y
			);

			let upgradePotential = "";
			let isMaxLevel = (level === upgrade.levels.length - 1);
			if (isMaxLevel) {
				upgradePotential = "Maxed out";
			} else {
				let nextValue = upgrade.levels[level + 1].value;
				let costMap = upgrade.levels[level + 1].cost;
				let costString = Array.from(costMap.entries())
					.map(costElement => {
						let costValue = costElement[1];
						let costUnit = RESOURCE_INFO.get(costElement[0])
							.displayName;
						return `${costValue} ${costUnit}`;
					})
					.join(', ');
				upgradePotential = `Upgrade for ${costString}`;
			}
			this.display.upgradeButton.update(
				this.colorBase,
				this.colorHighlight,
				upgradeButtonOrigin,
				upgradeButtonSize,
				upgradePotential
			);
		}


		// Old stuff

		// // Number of blocks in the upgrader: upgrades + thrusters
		// let numBlocks = Upgrader.UPGRADE_INFO.length + 1;

		// let blockSize = new Vector(
		// 	size.x,
		// 	(size.y - this.unicenter.requestMarginWidth(1) * (numBlocks - 1))
		// 					/ numBlocks
		// ).round();

		// // Refresh individual upgrade buttons
		// let buttonOrigin = new Vector();
		// for (let i = 0; i < Upgrader.UPGRADE_INFO.length; ++i) {
		// 	let upgrade = Upgrader.UPGRADE_INFO[i];
		// 	let level = this._levels[i];

		// 	let unit = upgrade.unit;

		// 	let currentInfo = `${upgrade.name}:`
		// 					+ ` ${upgrade.levels[level].value} ${unit}`;

		// 	let upgradePotential = "";
		// 	let isMaxLevel = (level === upgrade.levels.length - 1);
		// 	if (isMaxLevel) {
		// 		upgradePotential = "Maxed out";
		// 	} else {
		// 		let nextValue = upgrade.levels[level + 1].value;
		// 		let costMap = upgrade.levels[level + 1].cost;
		// 		let costString = Array.from(costMap.entries())
		// 			.map(costElement => {
		// 				let costValue = costElement[1];
		// 				let costUnit = RESOURCE_INFO.get(costElement[0])
		// 					.displayName;
		// 				return `${costValue} ${costUnit}`;
		// 			})
		// 			.join(', ');
		// 		upgradePotential = `Upgrade to ${nextValue} ${unit} for`
		// 						+ ` ${costString}`;
		// 	}

		// 	this.display.upgradeButtons.children[i].update(
		// 		0x1a2c17,
		// 		0x6aff4d,
		// 		buttonOrigin,
		// 		blockSize,
		// 		[currentInfo, upgradePotential]
		// 	);

		// 	buttonOrigin.y += blockSize.y
		// 					+ this.unicenter.requestMarginWidth(1);
		// }

		// // Refresh the forge button
		// let forgeText = this.thrustersForged ?
		// 	"Maneuvering thrusters forged, use them with (A)(S)(D)"
		// 					+ " or (\u2b05)(\u2b07)(\u27a1)"
		// 	: "Forge maneuvering thrusters (requires a star)";
		// this.display.forgeButton.update(
		// 	0x1a2c17,
		// 	0x6aff4d,
		// 	buttonOrigin,
		// 	blockSize,
		// 	forgeText
		// );
	}

	// Try to upgrade a technology and take away the items accordingly
	// This function does nothing if the upgrade is impossible. techIndex is an
	// index in Upgrader.UPGRADE_INFO.
	_tryUpgrade(techIndex) {
		let upgrade = Upgrader.UPGRADE_INFO[techIndex];
		let level = this._levels[techIndex];

		// Max level, upgrade impossible
		if (level === upgrade.levels.length - 1) return;

		let cost = upgrade.levels[level + 1].cost;

		// Insufficient funds, upgrade impossible
		if (!this.unicenter.refinery.canAfford(cost)) return;

		// All checks passed, do the upgrade
		++this._levels[techIndex];
		this.unicenter.refinery.deduct(cost);

		this.unicenter.ship.achievements.recordAchievement(ACHIEVEMENTS.UPGRADE);

		// No need to push upgrades anywhere - whatever needs the upgrade is
		// responsible for pulling it using this.getValue().
	}
}
